// Also detects iOS
export function isSafari() {
    return /apple/i.test(navigator.vendor);
}
export function isInternetExplorer() {
    return /MSIE |Trident\//.test(navigator.userAgent);
}
//# sourceMappingURL=Browser.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amcharts/amcharts4/.internal/core/utils/Browser.js
// module id = 802
// module chunks = 3